'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _highlight = require('highlight.js');

var _highlight2 = _interopRequireDefault(_highlight);

var _BareHighlight = require('./BareHighlight');

var _BareHighlight2 = _interopRequireDefault(_BareHighlight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Highlight = function Highlight(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, ['children']);

  // $FlowIssue does not support children


  return _react2.default.createElement(
    _BareHighlight2.default,
    _extends({}, rest, { highlightjs: _highlight2.default }),
    children
  );
};

Highlight.defaultProps = {
  className: '',
  languages: [],
  worker: null
};

Highlight.propTypes = {
  children: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  languages: _propTypes2.default.arrayOf(_propTypes2.default.string),
  worker: _propTypes2.default.object };

exports.default = Highlight;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-highlight/lib/Highlight.js
// module id = 644
// module chunks = 0